export default __webpack_public_path__ + "static/media/aws-white.71c0f99b.svg";